<template>
  <modal :is-active="true" @close="hide" :title="'Fläche bearbeiten'">
    <template #body>
      <div class="form-horizontal">
        <div class="form-group">
          <label for="booth_refinement" class="control-label">
            {{ $t('configurator.form.labels.current_surface') }}
          </label>
          <div class="row">
            <div class="col-sm-12">
              <p style="padding-bottom: 0;">{{ currentRefinement }}</p>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="booth_refinement" class="control-label">
            {{ $t('configurator.form.labels.choose_surface') }}<span>*</span>:
          </label>

          <div class="row">
            <div v-if="filteredRefinements.length === 0" class="col-sm-12">
              <p style="padding-bottom: 0;">
                {{ $t('configurator.labels.no_alternative_surfaces') }}
              </p>
            </div>

            <div v-for="availableRefinement in filteredRefinements"
              class="col-sm-6"
              :key="availableRefinement.id">
              <div class="radio">
                <label>
                  <input
                    type="radio"
                    name="request_article_id"
                    :id="'request_article_id' + availableRefinement.id"
                    :value="availableRefinement.id"
                    v-model="form.request_article_id"
                    style="width: 13px" />
                  <p style="padding-bottom: 0;">{{ (inEnglish) ? availableRefinement.article_print.name_en : availableRefinement.article_print.name }}</p>
                </label>
              </div>
            </div>
          </div>
          <p v-if="form.errors.has('request_article_id')" class="text-danger">
            {{ $t('configurator.form.errors.graphic_design') }}
          </p>
        </div>

        <div class="form-group text-center">
          <button type="button" class="btn btn-warning mr-2" @click.prevent="hide">
            {{ $t('configurator.buttons.cancel') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click.prevent="submit"
            :disabled="filteredRefinements.length === 0">
            {{ $t('configurator.buttons.update') }}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import Form from '@/classes/Form'
import { computed, reactive, onMounted } from 'vue'
import { useMainStore } from '@/store'
import { useCloudStore } from '@/stores/cloud'
import { showErrorToast, showLoadingIndicator, showSuccessToast } from '@/utils/toast'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
const cloudStore = useCloudStore()
// define props
const props = defineProps({
  configuration: {
    type: Object,
    required: true
  },
  article: {
    type: Object,
    required: true
  },
  index: {
    type: Number,
    required: true
  },
  printArticle: {
    type: Object,
    required: true
  }
})
// define emits
const emit = defineEmits(['hide'])
// define reactive props
const form = reactive(new Form({
  request_article_id: null,
  configuration_id: null,
}))
// define computed props
const inEnglish = computed(() => store.inEnglish)

const currentRefinement = computed(() => {
  return (inEnglish.value)
    ? props.printArticle.article_print.name_en
    : props.printArticle.article_print.name
})

const availableRefinements = computed(() => {
  return cloudStore.getAvailableArticleRefinements(
    props.article,
    [props.configuration],
    props.index
  )
})

const filteredRefinements = computed(() => {
  return availableRefinements.value.filter((availableRefinement) => {
    return availableRefinement.article_print.print_article_id === props.printArticle.article_print.print_article_id
  })
})
// define methods
const hide = () => {
  emit('hide')
}

const submit = async () => {
  showLoadingIndicator(
    t('configurator.indicators.update_surface'),
    t('configurator.indicators.one_moment_please')
  )
  await cloudStore.changeArticleRefinement(form, props.printArticle.id)
    .then(() => {
      showSuccessToast(t('configurator.toasts.messages.surface_updated'), t('toast.title.success'))
      hide()
    })
    .catch(() => showErrorToast(t('configurator.toasts.errors.surface_updated'), t('toast.title.error')))
}

onMounted(() => {
  form.configuration_id = props.configuration.id
})
</script>